export enum TipoReporte {
  reporteSaldo = 0,
  reporteSolicitante = 1,
  reporteAprobador = 2
}
